<script lang="ts">
	import Switch from '$lib/components/atoms/switch/Switch.svelte';
	import { getMapLayoutContext } from '$lib/components/map/map-layout-context';
	import { track } from '$lib/services/tracking/googleAnalytics';
	import * as m from '$paraglide/messages';

	const { isLowEmissionZoneLayerVisible, mapSettingsUserPreferencesLocalStorage } = getMapLayoutContext();

	function updateSwitchState() {
		$isLowEmissionZoneLayerVisible = !$isLowEmissionZoneLayerVisible;
		mapSettingsUserPreferencesLocalStorage.set('showLezLayer', $isLowEmissionZoneLayerVisible);
		track({
			action: 'low_emission_zone_layer',
			payload: {
				action: $isLowEmissionZoneLayerVisible ? 'on' : 'off',
				context: 'modal',
			},
		});
	}
</script>

<Switch
	id="low-emission-zone-switch"
	checked={$isLowEmissionZoneLayerVisible}
	onchange={updateSwitchState}
>
	<span class="text-md">{m.map_tools__low_emission_zone__label()}</span>
</Switch>
